var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardOrnament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 219,
    viewBox: "0 0 343 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 90.1882C270.129 178.161 -48.4326 195.923 -59.5 258.188H515.489C527.94 234.839 540.45 166.779 443.5 53.188C322.312 -88.8006 101.5 57.1879 147.5 90.1882Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOrnament);
export default __webpack_public_path__ + "static/media/credit-card-ornament.271a760a09d0c5ad22ddea6e6422f2ad.svg";
export { ForwardRef as ReactComponent };